module.exports = __webpack_public_path__ + "img/slider-6.0fbf838d.jpg";